/* OPARINA promo pop-up (demo DEC-36): after a delay or a scroll depth, once every N days, never over the cart drawer,
   a menu or another dialog, never by itself on product/cart pages. Closing folds it into the side tab, which reopens it.
   ?promo in the URL forces it (review). */
if (!customElements.get('oparina-promo')) {
  customElements.define(
    'oparina-promo',
    class OparinaPromo extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.tab = this.querySelector('[data-promo-tab]');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.ac = new AbortController();
        const sig = { signal: this.ac.signal };
        const d = this.dataset;
        const key = d.key || 'op-promo';
        const wait = (+d.days || 7) * 864e5;
        const remember = () => { try { localStorage.setItem(key, Date.now()); } catch (e) {} };
        let seen = 0;
        try { seen = +localStorage.getItem(key) || 0; } catch (e) {}
        this.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', () => this.dialog.close(), sig));
        this.querySelector('[data-promo-cta]')?.addEventListener('click', remember, sig);
        this.dialog.addEventListener('close', () => { remember(); this.tab.hidden = false; }, sig);
        this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); }, sig);   // backdrop
        this.tab.addEventListener('click', () => this.open(true), sig);
        // load Shopify's Customer Privacy API so the pop-up can wait for the cookie banner answer
        this.privacyChecked = false;
        if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => { this.privacyChecked = true; });
        } else {
          this.privacyChecked = true;
        }
        const force = new URLSearchParams(location.search).has('promo');
        if (window.Shopify?.designMode) { this.tab.hidden = false; return; }
        if (force) { this.open(true); return; }
        if (Date.now() - seen < wait || d.auto !== 'true') { this.tab.hidden = false; return; }
        const onScroll = () => {
          const depth = (document.documentElement.scrollHeight - innerHeight) * ((+d.scroll || 40) / 100);
          if (scrollY > depth) this.open(false);
        };
        const delay = +d.delay || 8000;
        this.timer = setTimeout(() => this.open(false), delay);
        // when the cookie banner was in the way, try again after the visitor answers it
        document.addEventListener('visitorConsentCollected', () => {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.open(false), 2500);
        }, sig);
        addEventListener('scroll', onScroll, { passive: true, signal: this.ac.signal });
        this.stopAuto = () => { clearTimeout(this.timer); removeEventListener('scroll', onScroll); };
      }

      consentPending() {
        // Shopify's privacy banner shows to visitors whose region requires it, until they answer
        const banner = document.getElementById('shopify-pc__banner');
        if (banner) {
          const r = banner.getBoundingClientRect();
          const st = getComputedStyle(banner);
          if (r.width > 0 && r.height > 0 && st.display !== 'none' && st.visibility !== 'hidden' && st.opacity !== '0') return true;
        }
        try {
          const cp = window.Shopify && window.Shopify.customerPrivacy;
          if (!cp) return !this.privacyChecked;   // API still loading: wait for it
          if (typeof cp.shouldShowBanner === 'function' && cp.shouldShowBanner()) {
            const c = typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : null;
            return !c || Object.values(c).some((v) => v === '');   // '' = not answered yet
          }
        } catch (e) {}
        return false;
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        clearTimeout(this.timer);
      }

      busy() {
        // never on top of the cart, a menu, search or another dialog
        if (document.querySelector('cart-drawer.active, cart-notification.active, .header__inline-menu details[open], details-modal details[open], menu-drawer details[open], dialog[open]')) return true;
        // Shopify's cookie banner first: the visitor answers it before any promotion
        return this.consentPending();
      }

      open(byUser) {
        if (this.dialog.open) return;
        if (!byUser && this.busy()) {   // try again shortly (scroll or consent events also retry)
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.open(false), 4000);
          return;
        }
        if (this.stopAuto) this.stopAuto();
        this.tab.hidden = true;
        this.dialog.showModal();
      }
    }
  );
}
